module.exports = "<header class=header> <div class=header__left></div> <div class=header__right> <div class=\"header__avatar avatar\"></div> </div> </header> ";